// test780
(780 && 0);
